import React, {FC} from 'react';
import {Widget} from '@typeform/embed-react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type TypeFormProps = {
	formId: string
}

const darkFormId = 'djfnTm5T';

const TypeForm: FC<TypeFormProps> = ({formId}) => {
	return (
		<div className={classNames({
			[styles.wrapper]: true,
			[styles.dark]: formId === darkFormId,
			[styles.salad]: formId !== darkFormId,
		})}>
			<Widget
				id={formId}
				className={styles.form}
				transitiveSearchParams={[
					'utm_source',
					'utm_medium',
					'utm_campaign',
					'utm_term',
				]}
			/>
		</div>
	);
};

export default TypeForm;
